<label
  class="label"
  [class.label-tooltip]="labelTooltip()"
  [ngClass]="labelClass()">
  {{ label() }}
  @if (labelTooltip()) {
    <pp-tooltip class="tooltip" [text]="labelTooltip().toString()" />
  }
</label>

<div class="value" [ngClass]="valueClass()">
  @if (value) {
    <div
      class="value-content"
      [style.max-width]="maxWidthStyle()"
      [class.content-width]="contentWidth()">
      <div
        #ellipsisEl
        [class.ellipsis]="ellipsis()"
        [innerHtml]="value.toString() | safeHtml"></div>
      @if (ellipsis() && ellipsisEl.clientWidth < ellipsisEl.scrollWidth) {
        <pp-tooltip [text]="value.toString()" [customContent]="true">
          <div class="tooltip-overlay"></div>
        </pp-tooltip>
      }
    </div>
  }

  <ng-content></ng-content>

  @if (isCopyBtn()) {
    <button
      class="copy-btn"
      type="button"
      puButton
      uiType="quaternary"
      size="s"
      [onlyIcon]="true"
      data-testid="copy_btn"
      (click)="copyToClipboard($event)">
      <pu-icon iconName="copy" size="16" />
    </button>
  }
</div>
